import Vue from 'vue'
import fetch from '@/lib/http'

const Plugin = {
  install(_Vue) {
    // alias
    _Vue.fetch = fetch
    _Vue.prototype.fetch = fetch
  },
}

Vue.use(Plugin)

export default Plugin
